module.exports = __webpack_public_path__ + "img/home.55b7a2bc.png";